var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAirplaneLanding = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 20.25H22.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.72233V4.79108C2.24999 4.67248 2.27811 4.55558 2.33204 4.44995C2.38597 4.34433 2.46418 4.253 2.56025 4.18346C2.65632 4.11393 2.76751 4.06816 2.8847 4.04993C3.00188 4.0317 3.12172 4.04152 3.23438 4.07858L4.5 4.50045L6 7.31295L9 8.25045V4.79108C8.99999 4.67248 9.02811 4.55558 9.08204 4.44995C9.13597 4.34433 9.21418 4.253 9.31025 4.18346C9.40632 4.11393 9.51751 4.06816 9.6347 4.04993C9.75188 4.0317 9.87172 4.04152 9.98438 4.07858L11.25 4.50045L14.25 9.75045L18.8063 11.0161C19.4377 11.1906 19.9944 11.5677 20.3907 12.0894C20.787 12.6111 21.0011 13.2484 21 13.9036V17.2505L4.44375 12.6098C3.8123 12.4353 3.25563 12.0582 2.8593 11.5365C2.46297 11.0148 2.24891 10.3775 2.25 9.72233V9.72233Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAirplaneLanding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/airplaneLanding.5849140ef492625b87b84e4513d0bd03.svg";